<template>
    <div class="form-opt-column-wrapper">
        <div class="operator-button" @click="setDefaultClick" v-show="!isDefaultForm">{{ setDefaultBtn }}</div>
        <div class="operator-button" @click="cancelDefaultClick" v-show="isDefaultForm">{{ cancelDefaultBtn }}</div>
        <div class="operator-button" @click="copyClick">{{ copyBtn }}</div>
        <div class="operator-button" @click="disableClick" v-show="stateCode">{{ stopBtn }}</div>
        <div class="operator-button" @click="enableClick" v-show="!stateCode">{{ startBtn }}</div>
        <div class="operator-button" @click="deleteClick" v-show="!stateCode">{{ deleteBtn }}</div>
    </div>
</template>

<script>
export default {
    name: "FormOptColumn",
    props: ["data", "row"],
    computed: {
        setDefaultBtn() {
            return this.$t("zhiji.common.setDefaultForm");
        },
        cancelDefaultBtn() {
            return this.$t("zhiji.common.cancelDefaultForm");
        },
        copyBtn() {
            return this.$t("zhiji.common.copy");
        },
        deleteBtn() {
            return this.$t("zhiji.common.delete");
        },
        stopBtn() {
            return this.$t("zhiji.common.stopUse");
        },
        startBtn() {
            return this.$t("zhiji.common.startUse");
        },
        stateCode() {
            return !!this.row.addData.stateCode;
        },
        formId() {
            return this.row.addData.rowId;
        },
        isDefaultForm() {
            return !!this.row.addData.isDefaultForm;
        },
    },
    methods: {
        setDefaultClick() {
            this.$store.dispatch("zhiji/setDefaultForm", {
                formId: this.formId,
                lang: this.row.addData.lang
            });
        },
        cancelDefaultClick() {
            this.$store.dispatch("zhiji/cancelDefaultForm", {
                formId: this.formId
            });
        },
        copyClick() {
            this.$store.dispatch("zhiji/copyForms", {
                formId: this.formId
            });
        },
        disableClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.form.stopUseFormTip"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/updateFormStatus", {
                            formId: this.formId,
                            status: 0
                        });
                    }
                }
            });
        },
        enableClick() {
            this.$store.dispatch("zhiji/updateFormStatus", {
                formId: this.formId,
                status: 1
            });
        },
        deleteClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.form.deleteFormTip"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/deleteForms", {
                            formId: this.formId
                        });
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.form-opt-column-wrapper {
    white-space: nowrap;
    .operator-button {
        display: inline-block;
        font-size: 12px;
        margin-right: 8px;
        border: 1px solid #d8e4f0;
        padding: 2px 8px;
        background: #fff;
        border-radius: 4px;
        &:hover {
            color: #2ec2ff;
            cursor: pointer;
        }
    }
}
</style>
